module.exports = __webpack_public_path__ + "img/Vector.44b1045f.svg";